import DataVisualizationTypeProvider from "./DataVisualizationTypeProvider";
import ChartOptionsProvider from "components/charting/providers/ChartOptionsProvider";
import ChartSelectionsProvider from "components/charting/providers/ChartSelectionsProvider";
import LoadingProvider from "providers/LoadingProvider";
import { athleteProfilingV2Enabled } from "config/features";
import ChartSetSelectProvider from "./ChartSetSelectProvider";
import ChartCompareSetSelectProvider from "./ChartCompareSetSelectProvider";
import ChartProfileSelectProvider from "./ChartProfileSelectProvider";
import ChartCompareProfileSelectProvider from "./ChartCompareProfileSelectProvider";
import ChartSetSelectionDefaultsProvider from "./ChartSetSelectionDefaultsProvider";

function ChartingProvidersV3(props: { children: React.ReactNode }) {
  return (
    <LoadingProvider>
      <ChartOptionsProvider>
        <ChartSelectionsProvider>
          <DataVisualizationTypeProvider>
            <ChartSetSelectProvider>
              <ChartCompareSetSelectProvider>
                {athleteProfilingV2Enabled ? (
                  <ChartProfileSelectProvider>
                    <ChartCompareProfileSelectProvider>
                      <ChartSetSelectionDefaultsProvider>{props.children}</ChartSetSelectionDefaultsProvider>
                    </ChartCompareProfileSelectProvider>
                  </ChartProfileSelectProvider>
                ) : (
                  <>{props.children}</>
                )}
              </ChartCompareSetSelectProvider>
            </ChartSetSelectProvider>
          </DataVisualizationTypeProvider>
        </ChartSelectionsProvider>
      </ChartOptionsProvider>
    </LoadingProvider>
  );
}
export default ChartingProvidersV3;
